export * from '@fhs/routing/src/routes/order-confirmation/[rbiOrderId]';
export { default } from '@fhs/routing/src/routes/order-confirmation/[rbiOrderId]';
